import { enqueueSnackbar } from "notistack";
import { apiCall } from ".";
import { getSession } from "../handlers/getSession";
import { getTenant } from "../handlers/getTenant";
import { getErrorMessage } from "./errorMessages";

//function to handle errors and display them to the user
const showErrorMessage = (message) => {
  enqueueSnackbar(message, {
    variant: "error",
    preventDuplicate: true,
    autoHideDuration: 10000,
  });
};

const showSuccessMessage = (msg) => {
  enqueueSnackbar(`${msg}`, {
    variant: "success",
    preventDuplicate: true,
  });
};

export const getUserList = async () => {
  const session = getSession();
  const tenant = getTenant();
  if (!session) return;
  try {
    const resp = await apiCall.get(`${tenant}/api/list/user/`, {
      headers: {
        IdToken: session.IdToken,
        Authorization: `Bearer ${session.AccessToken}`,
      },
    });
    return resp.data;
  } catch (error) {
    const errorMessage = getErrorMessage(error, "users");
    showErrorMessage(errorMessage);
    console.error(error);
    throw new Error(errorMessage, { cause: error });
  }
};

export const createUser = async (data) => {
  const session = getSession();
  const tenant = getTenant();
  if (!session) return;
  try {
    const resp = await apiCall.post(`${tenant}/api/create/user/`, data, {
      headers: {
        IdToken: session.IdToken,
        Authorization: `Bearer ${session.AccessToken}`,
      },
    });
    return resp;
  } catch (resp) {
    // return {
    //   error: true,
    //   message: resp.response.data.errors ? JSON.stringify(resp.response.data.errors) : resp.response.data.message ? resp.response.data.message : "error",
    // };
    throw new Error(resp.response.data.errors ? JSON.stringify(resp.response.data.errors) : resp.response.data.message ? resp.response.data.message : "error",)
  }
};

export const confirmUser = async (email = "", verification_code = "") => {
  const session = getSession();
  const tenant = getTenant();
  if (!session) return;
  try {
    const resp = await apiCall.post(`${tenant}/api/confirm/user/`, {
      email,
      verification_code,
    });
    return resp.data;
  } catch (error) {
    showErrorMessage(getErrorMessage(error, "auth_recovery"));
    console.error(error.message);
  }
};


export const updateUserRoles = async (data) => {
  const session = getSession();
  const tenant = getTenant();
  try {
    const resp = await apiCall.put(`${tenant}/api/report/update-users-from-report/?report_id=${data.reportId}`, data, {
      headers: {
        IdToken: session.IdToken,
        Authorization: `Bearer ${session.AccessToken}`,
        'Content-Type': 'application/json', 
      },
    });
    return resp.data;
  } catch (resp) {
    throw new Error(resp.response.data.errors ? JSON.stringify(resp.response.data.errors) : resp.response.data.message ? resp.response.data.message : "error",)
  }
};

export const userInsertInToGroup = async (data) => {
  const session = getSession();
  const tenant = getTenant();
  if (!session) return;
  try {
    const resp = await apiCall.post(`${tenant}/api/user/insert/groups/`, data, {
      headers: {
        IdToken: session.IdToken,
        Authorization: `Bearer ${session.AccessToken}`,
      },
    });
    return resp.data;
  } catch (error) {
    showErrorMessage(getErrorMessage(error, "users"));
    console.error(error.message);
  }
};

export const userEnableDisable = async(request_status, email) => {
  const session = getSession();
  const tenant = getTenant();
  if (!session) return;
  try {
    const resp = await apiCall.post(`${tenant}/api/user/enabledisable/`, { request_status, email }, {
      headers: {
        IdToken: session.IdToken,
        Authorization: `Bearer ${session.AccessToken}`,
      },
    });
    return resp.data;
  } catch (error) {
    throw new Error(getErrorMessage(error, "users"), { cause: error });
  }
}

// Send code for reset password
export const sendCodeResetPassword = async (email) => {
  try {
    const resp = await apiCall.post("/reset_password/", { email });
    return resp;
  } catch (error) {
    showErrorMessage(getErrorMessage(error, "auth_recovery"));
    console.error(error.message);
  }
};

// Reset password confirmation
// export const resetPasswordConfirm = async (
//   email,
//   confirmation_code,
//   new_password
// ) => {
//   try {
//     const resp = await apiCall.post("/confirm_reset_password/", {
//       email,
//       confirmation_code,
//       new_password,
//     });
//     return resp;
//   } catch (error) {
//     showErrorMessage(getErrorMessage(error, "users"));
//     console.error(error.message);
//   }
// };

// Reset password confirmation
export const resetPasswordConfirm = async (
  email,
  password,
  cpassword
) => {
  const session = getSession();
  const tenant = getTenant();
  try {
    const resp = await apiCall.post(`${tenant}/api/user/change_password/`, {
      email,
      password,
      cpassword,
    }, {
      headers: {
        IdToken: session.IdToken,
        Authorization: `Bearer ${session.AccessToken}`,
      }
    });
    return resp;
  } catch (error) {
    console.log(error);
    showErrorMessage(getErrorMessage(error, "auth_recovery"));
    throw error;
  }
};

export const resetMyPasswordConfirm = async (
  email,
  password,
  cpassword
) => {
  const session = getSession();
  const tenant = getTenant();
  try {
    const resp = await apiCall.post(`${tenant}/api/user/change_my_password/`, {
      email,
      password,
      cpassword,
    }, {
      headers: {
        IdToken: session.IdToken,
        Authorization: `Bearer ${session.AccessToken}`,
      }
    });
    return resp;
  } catch (error) {
    console.log(error);
    showErrorMessage(getErrorMessage(error, "auth_recovery"));
    throw error;
  }
};

export const enableMFA = async (data) => {
  const session = getSession();
  const tenant = getTenant();

  if (!session) return;
  try {
    const resp = await apiCall.post(`${tenant}/api/cognito/setup_mfa_totp/`, data, {
      headers: {
        IdToken: session.IdToken,
        Authorization: `Bearer ${session.AccessToken}`,
      },
    });
    return resp.data;
  } catch (error) {
    showErrorMessage(getErrorMessage(error, "auth_recovery"));
    console.error(error);
  }
};

export const verifyMFA = async (otp_code) => {
  const session = getSession();
  const tenant = getTenant();

  if (!session) return;
  try {
    const resp = await apiCall.post(`${tenant}/api/cognito/verify_mfa_totp/`, {
      otp_code
    }, {
      headers: {
        IdToken: session.IdToken,
        Authorization: `Bearer ${session.AccessToken}`,
      },
    });
    return resp.data;
  } catch (error) {
    showErrorMessage(getErrorMessage(error, "auth_recovery"));
    console.error(error);
  }
};

/**
 * Get user details by ID
 * @param {number|string} userId - The user ID to fetch
 * @returns {Promise<{user: object}|null>} User details or null on error
 */
export const getUserDetail = async (userId) => {
  const session = getSession();
  const tenant = getTenant();
  if (!session) return null;
  try {
    const resp = await apiCall.get(`${tenant}/api/user/detail/?id=${userId}`, {
      headers: {
        IdToken: session.IdToken,
        Authorization: `Bearer ${session.AccessToken}`,
      },
    });
    return resp.data;
  } catch (error) {
    console.error(`Error fetching user ${userId}:`, error.message);
    return null;
  }
};